export const CreateEventGroupings = (events, maxColumns = 4) => {
  // second pass (sorting) (-1 means move to lower index, 1 means move to higher index)
  events.sort((a, b) => {
    if (a.top < b.top) return -1
    else if (a.top === b.top && a.bottom - a.top > b.bottom - b.top) return -1
    else return 1
  })

  // third pass
  // assumes events are sorted depending on start date
  /**
   *
   * {
   *  min: // lowest start date
   *  max: // highest end date
   *  columns: [] // level 0: columns, level 1: column events
   * }
   */
  let groupings = [] // 3 levels:   level 0 = groupings, level 1 = columns, level 2 = events
  let gi = 0 // group index
  let gc = null // group current
  for (let i = 0; i < events.length; i++) {
    let ev = events[i]
    // check if gc is empty
    if (!gc || ev.top > gc.max) {
      groupings[gi++] = gc = {
        min: events[i].top,
        max: events[i].bottom,
        columns: [],
        // more: { // will be defined if column size exceeds max column
        //   event: ev,
        //   top: 0,
        //   bottom: 0,
        //   left: 0,
        //   right: 0,
        //   title,
        // },
      }
    }

    // check column levels if "prev start date <= start date" <= "prev end date"
    // infinite loop
    for (let ci = 0; ; ci++) {
      if (!gc.columns[ci]) {
        gc.columns.push([])
      }
      let c = gc.columns[ci]
      // check if there's an item that overlaps start
      let hasStartOverlap = !!c.find(f => f.top <= ev.top && f.bottom >= ev.top)
      // check if there's an item that overlaps end
      let hasEndOverlap = !!c.find(f => f.top <= ev.bottom && f.bottom >= ev.bottom)

      if (hasStartOverlap || hasEndOverlap) {
        continue
      } else {
        gc.min = Math.min(ev.top, gc.min)
        gc.max = Math.max(ev.bottom, gc.max)
        c.push(ev)
        break
      }
    }
  }

  // consolidate extra columns
  for (let i = 0; i < groupings.length; i++) {
    let g = groupings[i]
    if (g.columns.length > maxColumns) {
      let evs = g.columns.splice(maxColumns - 1).flat(1) // flatten
      g.more = {
        events: evs,
        top: Math.min(...evs.map(e => e.top)),
        bottom: Math.max(...evs.map(e => e.bottom)),
        left: 0,
        right: 0,
        title: `+${evs.length} More`,
      }
    }
  }

  return groupings
}
